import {
  Component,
  OnInit,
  HostBinding,
  Input,
  SimpleChanges,
  OnChanges,
  ViewChild,
  ElementRef,
  AfterViewInit,
  Renderer2,
  HostListener,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ChildEventChannel } from '../../core/events/child-event-channel';

import {
  animateListItemActive,
  animateListItemInactive,
} from '../pg-list-select.animations';
import { ENTER } from '@angular/cdk/keycodes';
import { AnimationService } from '../../core/ui/animation.service';

@Component({
  selector: 'pg-list-select-item, grit-list-select-item',
  templateUrl: './pg-list-select-item.component.html',
  styleUrls: ['./pg-list-select-item.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PgListSelectItemComponent {
  animationDuration = 150;
  get active(): boolean {
    return this._active;
  }
  set active(value) {
    if (value !== this._active) {
      this._setActiveState(value);
      this._active = value;
      this._ariaSelected = this._active.toString();
    }
  }
  @HostListener('keydown', ['$event']) _handleKeyDown(event: KeyboardEvent) {
    if (event.keyCode === ENTER && !this._active) {
      this._eventChannel.emit(this);
    }
  }

  @HostBinding('class.active')
  public _active = false;

  @HostBinding('class.pg-elevation-1')
  get _elevationClass1() {
    return !this.active;
  }

  @HostBinding('attr.role') _role = 'option';
  @HostBinding('attr.aria-selected') _ariaSelected;
  @HostBinding('attr.tabindex') tabIndex = 0;

  @HostBinding('class.pg-elevation-2')
  get _elevationClass2() {
    return this.active;
  }

  @Input()
  value: any;

  _globalPromise = Promise.resolve();

  @ViewChild('subtitleWrapper', { static: true })
  _subtitleWrapperChild: ElementRef;
  get subtitleWrapperEl(): HTMLElement {
    return this._subtitleWrapperChild.nativeElement;
  }

  get hostEl(): HTMLElement {
    return this.elementRef.nativeElement;
  }
  constructor(
    public elementRef: ElementRef,
    public _renderer: Renderer2,
    public _animation: AnimationService,
    private _eventChannel: ChildEventChannel
  ) {}

  private _setActiveState(active) {
    active
      ? this._schedulePromise(() => animateListItemActive.call(this))
      : this._schedulePromise(() => animateListItemInactive.call(this));
  }

  @HostListener('click')
  handleClicked() {
    this._eventChannel.emit(this);
  }

  private _schedulePromise(cb) {
    const p = this._globalPromise.then(() => cb());
    this._globalPromise = p;
  }
}
